import React from 'react';

import SubHeading from '../SubHeading/SubHeading';
import './Newsletter.css';

const Newsletter = () => (
  <div className="app__newsletter">
    <div className="app__newsletter-heading">
      <SubHeading title="Divine Nail Spa" />
      <h1 className="headtext__cormorant">How to Book an Appointment</h1>
      <p className="p__opensans">Call us at 703-753-5586</p>
    </div>

  </div>
);

export default Newsletter;